import { CssBaseline } from '@mui/material';
import { HashRouter } from 'react-router-dom';
import { ThemeContextProvider } from '../shared/contexts/ThemeContextProvider';
import { UserPreferencesProvider } from '../shared/contexts/UserPreferencesContext';
import { getUser, updatePreferences } from '../features/users';
import { PageLayout } from '../shared/ui/PageLayout';

const App = () => {
  return (
    <UserPreferencesProvider
      fetchUser={getUser}
      savePreferences={updatePreferences}
    >
      <ThemeContextProvider>
        <HashRouter>
          <PageLayout>
            <>
              <CssBaseline />
            </>
          </PageLayout>
        </HashRouter>
      </ThemeContextProvider>
    </UserPreferencesProvider>
  );
};

export default App;
